import { Plus } from "@phosphor-icons/react";

export function MasterAddForm({ fields, form, setForm, onSubmit, testPrefix }) {
  return (
    <form onSubmit={onSubmit} className="flex flex-wrap items-end gap-2 border-b border-slate-200 bg-slate-50 p-3">
      {fields.map((f) =>
        f.type === "select" ? (
          <select key={f.key} data-testid={`${testPrefix}-${f.key}-input`} required value={form[f.key] || ""}
            onChange={(e) => setForm((p) => ({ ...p, [f.key]: e.target.value }))}
            className="rounded-md border border-slate-300 bg-white px-2 py-2 text-sm outline-none">
            <option value="">{f.label}…</option>
            {f.options.map(([v, label]) => <option key={v} value={v}>{label}</option>)}
          </select>
        ) : (
          <input key={f.key} data-testid={`${testPrefix}-${f.key}-input`} required value={form[f.key] || ""}
            onChange={(e) => setForm((p) => ({ ...p, [f.key]: e.target.value }))} placeholder={f.label}
            className="min-w-[140px] flex-1 rounded-md border border-slate-300 bg-white px-3 py-2 text-sm outline-none transition-colors duration-150 focus:border-slate-900" />
        )
      )}
      <button data-testid={`${testPrefix}-add-button`} type="submit"
        className="flex items-center gap-1.5 rounded-md bg-slate-900 px-3 py-2 text-sm font-semibold text-white transition-colors duration-150 hover:bg-slate-700">
        <Plus size={14} weight="bold" /> Add
      </button>
    </form>
  );
}
